import React from 'react';
import '../styles/ProgressBar.css';

/**
 * Componente riutilizzabile per visualizzare una barra di progresso
 * 
 * @param {Object} props - Proprietà del componente
 * @param {number} props.current - L'indice corrente (inizia da 1)
 * @param {number} props.total - Il numero totale di elementi
 * @param {string} [props.className] - Classe CSS aggiuntiva
 * @returns {JSX.Element} Componente barra di progresso
 */
const ProgressBar = ({ current, total, className = '' }) => {
  // Calcola la percentuale di completamento
  const percentage = ((current / total) * 100).toFixed(0);
  
  return (
    <div className={`progress-container ${className}`}>
      <div className="progress-text">
        <span><span className="current">{current}</span> di {total}</span>
      </div>
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar; 